import type { FulfillmentStepKind, OrderFulfillmentDto } from "client/api-v2";

export async function completeFulfilmentStep(
  _fulfillmentId: string,
  _step: FulfillmentStepKind,
  _details?: string
): Promise<OrderFulfillmentDto> {
  throw new Error("Completing a fulfillment step is not supported: no backend route exists for it.");
}

export async function reopenFulfilmentStep(
  _fulfillmentId: string,
  _step: FulfillmentStepKind,
  _reason: string
): Promise<OrderFulfillmentDto> {
  throw new Error("Reopening a fulfillment step is not supported: no backend route exists for it.");
}
